import { storageManager } from '@authFlow/utils/SessionStorageManager';
import { isFeatureFlagActive } from '@authFlow/utils/experiments/isFeatureFlagActive';
import { isCustom } from '@authFlow/utils/signupHelpers';

const runReverseSemrushOne = () => {
  if (
    !isFeatureFlagActive('reverse_semrush_one') ||
    !(window.WTE && typeof window.WTE.CookieExperiment === 'function') ||
    window.location.pathname !== '/signup/'
  ) {
    return;
  }

  const src = storageManager.get('src');
  const tk = storageManager.get('tk');
  const userData = storageManager.get('userData');

  const experiment = new window.WTE.CookieExperiment({
    expId: '15e5dfafa66e49638c0fb599',
    weights: [0.5, 0.5],
  });

  if (
    src === 'header' ||
    src === 'main_promo' ||
    (src === 'main_slider' && tk === 'seo') ||
    (src === 'main_cta' && !userData?.keyword && !isCustom('copilot'))
  ) {
    experiment.run();
    if (experiment.variant === 0) {
      storageManager.remove('custom');
      storageManager.set({ flowTheme: 'default' });
    }

    if (experiment.variant === 1) {
      storageManager.set({
        custom: 'ai-seo',
        flowTheme: 'wow_ai_seo',
      });
    }
  }
};

export default runReverseSemrushOne;
